import { Box, Typography } from "@mui/material";
import { DeliveryTruckIcon } from "../../icons";
import { DetailsView } from "../SummaryCard/DetailsView";
import { SummaryBox } from "../SummaryCard/SummaryBox";
import { IconViewProps, SummaryCardWithIconProps } from "./SummaryCardWithIconProps.types";

export const IconView = ({ icon: Icon = DeliveryTruckIcon, iconColor = "#FFFFFF" }: IconViewProps) => {
  return (
    <Box
      sx={{
        bgcolor: "primary.dark",
        padding: "0.75rem",
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Icon sx={{ color: iconColor }} />
    </Box>
  );
};
export function SummaryCardWithIcon({ title = "", info = "Total orders", icon, color, iconColor }: SummaryCardWithIconProps) {
  return (
    <SummaryBox color={color}>
      <IconView icon={icon} iconColor={iconColor} />
      <DetailsView info={info} title={title} />
    </SummaryBox>
  );
}
